package com.example.ramsembedded.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.example.ramsembedded.components.layouts.PageLayout
import com.varabyte.kobweb.compose.css.AlignItems
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.alignItems
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.textAlign
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.lineHeight
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Page
@Composable
fun MileStonesPage() {
    PageLayout("MileStones"){
        Section(attrs = {
        }) {
            // Heading
            H1(attrs = { style { textAlign(TextAlign.Center); marginBottom(2.cssRem) } }) {
                SpanText("Milestones of RAMS Embedded IT Solutions Pvt Ltd")
            }

            // Milestones List
            Div(attrs = { style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(
                AlignItems.Center) } }) {
                // Milestone 1: Number of Batches Completed
                MilestoneItem("More Than X Batches Completed: Over the years, RAMS Embedded has successfully conducted a large number of training batches, continuously evolving our curriculum and delivery to meet industry demands.")

                // Milestone 2: Number of Students Trained and Placed
                MilestoneItem("1000+ Students Trained and Placed: Our training programs have empowered more than 1000 students with essential embedded systems skills. These graduates have secured positions in leading MNCs and other prestigious companies worldwide, marking a significant impact on their careers and the industry.")

                // Milestone 3: Years Since Establishment
                MilestoneItem("X Years Since Establishment: With over X years of experience in the embedded systems training sector, RAMS Embedded has established itself as a trusted name in the field, continuously adapting to the ever-changing technological landscape.")

                // Milestone 4: Experienced Faculty
                MilestoneItem("10+ Years of Experienced Faculty: Our faculty members bring over 10 years of industry experience to the classroom. They are experts in their fields, combining theoretical knowledge with practical insights, ensuring students receive top-notch training that is both relevant and industry-ready.")
            }
        }
    }
}

@Composable
fun MilestoneItem(description: String) {
    // Remember the hover state
    val isHovered = remember { mutableStateOf(false) }

    // Apply styles conditionally based on hover state
    Div(attrs = {
        style {
            display(DisplayStyle.Flex)
            justifyContent(JustifyContent.Start)
            alignItems(AlignItems.Center)
            padding(1.5.cssRem)
            borderRadius(8.cssRem)
            backgroundColor(if (isHovered.value) Color("#E8F1FF") else Color("#FFFFFF")) // Hover color change
            boxShadow("0 2px 4px rgba(0, 0, 0, 0.1)")
            marginBottom(1.5.cssRem)
        }
        // Mouse enter and leave events to track hover state
        onMouseEnter { isHovered.value = true }
        onMouseLeave { isHovered.value = false }
    }) {
        // Icon or Image can be added here (optional)
        Span(attrs = {
            style {
                fontSize(2.cssRem)
                color(Color("#4CAF50")) // Green color for the icon
                marginRight(1.2.cssRem)
            }
        }) {
            Text("✔️") // Icon for visual representation
        }
        Span(attrs = {
            style {
                fontSize(1.4.cssRem)
                color(Color("#333333"))
                lineHeight("1.6")
            }
        }) {
            Text(description)
        }
    }
}